import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LoginLayout from '../Login/components/LoginLayout'
import { Container, Box, Button, Typography } from '@mui/material'
import useFirebaseAuthentication from '../../utils/Firebase/hooks/useFirebaseAuthentication'
import useSetUserGHLToken from '../../api/user/setUserGHLToken'
import { CircularProgress, Stack } from '@mui/material'

const CrmStatusPage = () => {
	const { authUser } = useFirebaseAuthentication()

	const { setUserGHLToken, error, isLoading } = useSetUserGHLToken()

	const navigate = useNavigate()

	const handleGoToHome = () => {
		console.log('handleGoToHome')
		navigate('/')
	}

	useEffect(() => {
		if (authUser) {
			const queryParams = new URLSearchParams(window.location.search)
			const paramValue = queryParams.get('code')
			if (paramValue) {
				setUserGHLToken(queryParams)
			}
		}
	}, [authUser])

	if (isLoading) {
		return (
			<Stack justifyContent="center" height="100vh" alignItems="center">
				<CircularProgress />
			</Stack>
		)
	}

	if (authUser) {
		const queryParams = new URLSearchParams(window.location.search)
		const paramValue = queryParams.get('code')

		if (paramValue) {
			if (error) {
				return (
					<LoginLayout>
						<Container component="main" maxWidth="xs">
							<Box component="form" sx={{ mt: 1 }}>
								<Typography variant="h1" sx={{ padding: 2 }} component="h1">
									Error Connecting to the CRM, try again
								</Typography>
							</Box>
						</Container>
					</LoginLayout>
				)
			} else {
				return (
					<LoginLayout>
						<Container component="main" maxWidth="xs">
							<Box component="form" onSubmit={handleGoToHome} sx={{ mt: 1 }}>
								<Typography variant="h1" sx={{ padding: 2 }} component="h1">
									Connected to CRM Successfully
								</Typography>
								<Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
									Go to Home
								</Button>
							</Box>
						</Container>
					</LoginLayout>
				)
			}
		} else {
			return (
				<LoginLayout>
					<Container component="main" maxWidth="xs">
						<Box component="form" onSubmit={handleGoToHome} sx={{ mt: 1 }}>
							<Typography variant="h1" sx={{ padding: 2 }} component="h1">
								No code provided
							</Typography>
						</Box>
					</Container>
				</LoginLayout>
			)
		}
	}
}

export default CrmStatusPage
